import { restApi } from '../../api/restApiSlice';

/** Mirrors the server's `VerificationOutcome` (PRE-3287). */
export type CfVerificationResponse = {
  verified: boolean;
  attempts: number;
  elapsedMs: number;
};

const cloudflareVerificationApi = restApi.injectEndpoints({
  endpoints: (builder) => ({
    verifyCfIntegration: builder.mutation<
      CfVerificationResponse,
      { domain: string }
    >({
      query: ({ domain }) => ({
        url: '/v3/cloudflare/verification',
        method: 'POST',
        params: { domain },
      }),
    }),
  }),
});

export { cloudflareVerificationApi };
export const { useVerifyCfIntegrationMutation } = cloudflareVerificationApi;
